/**
 * Weiterleitung nach der Anmeldung an die Plattform (login#2).
 *
 * DER BEFUND: Hier wurde das Sitzungstoken an die Zieladresse gehaengt
 * (`?token=eyJ...`). Query-Strings landen im Browserverlauf, in den
 * Zugriffsprotokollen jedes Proxys auf dem Weg und im Referer - und das Token
 * gilt sieben Tage.
 *
 * JETZT holen wir beim Backend einen Einmal-Code (POST login/code, 60 s,
 * einmal einloesbar, an Benutzer und Sitzung gebunden) und haengen nur ihn an
 * (`?loginCode=`). Die Plattform tauscht ihn sofort gegen das Token und
 * entfernt ihn aus der Adresszeile (api, dataFromLoginService). Ein Code aus
 * einem Protokoll ist danach wertlos.
 *
 * Bewusst KEIN Rueckfall auf das Token, wenn der Code nicht zu bekommen ist:
 * Der Rueckfall waere genau die Luecke, die geschlossen werden soll. Dann
 * bleibt der Anwender mit einer Meldung auf der Anmeldeseite.
 *
 * formTypeParam und redirectParam reisen wie bisher im Query-String mit - sie
 * sind unkritisch und werden in der Plattform gelesen.
 */

/**
 * Baut die Zieladresse mit Einmal-Code.
 *
 * @param {string} ziel          bereits geprueftes Ziel (sicheresZiel)
 * @param {string} code          Einmal-Code vom Backend
 * @param {string} formType      formTypeParam
 * @param {string} redirectParam redirectParam
 * @returns {string}
 */
export function zielMitCode(ziel, code, formType, redirectParam) {
  const href = new URL(ziel);

  href.searchParams.append("loginCode", code);
  href.searchParams.append("formTypeParam", formType);
  href.searchParams.append("redirectParam", redirectParam);

  return href.toString();
}

/**
 * Holt den Code und leitet weiter. Liefert false, wenn kein Code zu bekommen
 * war - dann bleibt die Seite stehen, die Meldung kommt aus dem Store.
 */
export async function weiterleiten(store, ziel, formType, redirectParam) {
  const code = await store.dispatch("anmeldeCode");

  if (!code) {
    return false;
  }

  window.location.replace(zielMitCode(ziel, code, formType, redirectParam));
  return true;
}
